module.exports = __webpack_public_path__ + "static/OP3-2e7e2512f1b891852172805b23efd4f3.jpg";